import { applyMiddleware, compose, createStore, thunk } from '@local/finsera-core';

import rootReducer from './reducers/index';

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk as any)));

export type RootState = ReturnType<typeof store.getState>;
